import { render, staticRenderFns } from "./BoxOne.vue?vue&type=template&id=40b051d0&scoped=true"
import script from "./BoxOne.vue?vue&type=script&lang=js"
export * from "./BoxOne.vue?vue&type=script&lang=js"
import style0 from "./BoxOne.vue?vue&type=style&index=0&id=40b051d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b051d0",
  null
  
)

export default component.exports